/* ll-mobile-app.js
   Behaviour for the phone app shell: the Shop sheet and the watchlist badge.

   Every lookup is guarded. This file runs on every page of the store including
   ones that render no tab bar at all, so it must be inert rather than throwing
   when its elements are absent. The search app's own theme script threw on a
   missing element for exactly this reason and killed the rest of its handler.

   No dependencies, no build step, deferred from layout/theme.liquid. */
(function () {
  'use strict';

  /* ── Shop sheet ───────────────────────────────────────────────────────── */
  var sheet = document.getElementById('ll-shop-sheet');
  var opener = document.querySelector('[data-llmt-shop]');

  if (sheet && opener) {
    var panel = sheet.querySelector('.llmt-sheet__panel');
    var lastFocus = null;

    var open = function () {
      lastFocus = document.activeElement;
      sheet.hidden = false;
      /* Force a synchronous reflow, then add the class. Reading offsetHeight
         flushes layout so the browser has a start value for the transform and
         actually animates it. requestAnimationFrame was used here first, but it
         is throttled to zero in hidden or backgrounded tabs, which left the
         panel permanently translated off screen with the sheet marked open. */
      if (panel) void panel.offsetHeight;
      sheet.classList.add('is-open');
      document.body.classList.add('llmt-locked');
      opener.setAttribute('aria-expanded', 'true');
      var first = sheet.querySelector('a, button');
      if (first) first.focus({ preventScroll: true });
    };

    var close = function () {
      sheet.classList.remove('is-open');
      document.body.classList.remove('llmt-locked');
      opener.setAttribute('aria-expanded', 'false');
      var done = function () { sheet.hidden = true; };
      /* Wait for the slide-down, but never hang if the transition never fires
         (reduced motion, background tab, transition removed by a later style). */
      var settled = false;
      var finish = function () { if (!settled) { settled = true; done(); } };
      if (panel) panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    opener.addEventListener('click', function (e) {
      e.preventDefault();
      if (sheet.hidden) open(); else close();
    });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-llmt-close]')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !sheet.hidden) close();
    });

    /* Drag the handle downward to dismiss, the gesture the shape implies.
       Anything past a third of the panel height, or a decisive flick, closes;
       otherwise it springs back. */
    var grab = sheet.querySelector('[data-llmt-grab]');
    if (grab && panel) {
      var startY = 0, lastY = 0, startT = 0, dragging = false;

      grab.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        dragging = true;
        startY = lastY = e.touches[0].clientY;
        startT = Date.now();
        panel.style.transition = 'none';
      }, { passive: true });

      grab.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches || !e.touches.length) return;
        lastY = e.touches[0].clientY;
        var dy = Math.max(0, lastY - startY);
        panel.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });

      grab.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        panel.style.transition = '';
        panel.style.transform = '';
        var dy = lastY - startY;
        var fast = (Date.now() - startT) < 300 && dy > 60;
        if (dy > panel.offsetHeight / 3 || fast) close();
      });
    }
  }

  /* ── Watchlist badge ──────────────────────────────────────────────────────
     Reads the same localStorage shape the rest of the store writes:
       ll_watchlist   array of product handles
       ll-ur-watch    legacy mirror, read only if the modern key is absent
     and refreshes on the ll:watchlist:change event those writers dispatch, so
     adding from a product card updates the badge with no page load.          */
  var badge = document.querySelector('[data-llmt-watch-count]');

  if (badge) {
    var readCount = function () {
      try {
        var raw = localStorage.getItem('ll_watchlist');
        if (raw === null) raw = localStorage.getItem('ll-ur-watch');
        var list = JSON.parse(raw || '[]');
        return Object.prototype.toString.call(list) === '[object Array]' ? list.length : 0;
      } catch (e) {
        /* Private mode and blocked site data both throw on access. A missing
           badge is the right failure here, not a broken page. */
        return 0;
      }
    };

    var paint = function () {
      var n = readCount();
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.hidden = n === 0;
    };

    paint();
    document.addEventListener('ll:watchlist:change', paint);
    /* Another tab may have changed it. */
    window.addEventListener('storage', function (e) {
      if (!e.key || e.key === 'll_watchlist' || e.key === 'll-ur-watch') paint();
    });
  }
}());

/* ── Sticky identity strip (product template) ─────────────────────────────
   Thumbnail, product name, watchlist bell. No price and no buy button: the
   section renders its own sticky purchase bar below this one carrying all
   three, and having both put two Add to basket buttons on screen at once,
   stacked one above the other, saying the same thing at different sizes.

   Reveal rule: once the product's primary control has left the viewport.
   WHICH control that is depends on the product. Normally it is the Add to
   cart. On a sold-out product the theme hides that (offsetParent null, zero
   box, the label already changed to Out of stock) and the page's own
   watchlist bell becomes the primary control, so the bell is what the strip
   follows instead.

   This used to refuse to appear at all when there was no usable Add to cart,
   which was inherited from when the strip WAS a buy bar: a buy bar with
   nothing to buy is worse than no bar. That reasoning stopped applying the
   moment the strip became a bell. Sold out is exactly when a shopper wants
   the watchlist, and it was the one case where the strip refused to show.
   */
(function () {
  'use strict';

  var bar = document.querySelector('[data-ll-buybar]');
  if (!bar) return;

  var form = document.getElementById('pdp-form');
  var realBtn = form ? form.querySelector('[data-atc]') : document.querySelector('[data-atc]');
  var pageWatch = document.querySelector('[data-pdp-watch]');

  /* Nothing to follow and nothing to offer. */
  if (!realBtn && !pageWatch) return;

  /* offsetParent is null for anything display:none or inside it, which is how
     the theme hides the purchase controls on a sold-out product. */
  var onPage = function (el) {
    return !!el && el.offsetParent !== null && el.getBoundingClientRect().height > 0;
  };

  /* Resolved on every pass rather than once at load, because a variant switch
     can move a product between in stock and sold out, and that changes which
     control the strip should be following. */
  var anchor = function () {
    if (onPage(realBtn)) return realBtn;
    if (onPage(pageWatch)) return pageWatch;
    return null;
  };

  var show = function () {
    bar.hidden = false;
    void bar.offsetHeight;
    bar.classList.add('is-up');
    bar.setAttribute('aria-hidden', 'false');
  };

  var hide = function () {
    bar.classList.remove('is-up');
    bar.setAttribute('aria-hidden', 'true');
  };

  /* Reveal when the real button leaves the viewport.

     IntersectionObserver was the first approach and it was wrong here. IO
     reports intersection against the nearest clipping ancestors as well as the
     viewport, and the product gallery wraps this button in an overflow context,
     so IO reported isIntersecting false while the button was plainly on screen.
     The bar therefore never dropped back down.

     A bounding-rect test against the viewport is what the rule actually means,
     and it does not care what any ancestor clips. Scroll listeners are passive
     and the work is one rect read, so this is cheap.                          */
  var update = function () {
    var el = anchor();
    /* Neither control is on the page: no bell to offer, so stay down. */
    if (!el) { hide(); return; }
    var r = el.getBoundingClientRect();
    var onScreen = r.bottom > 0 && r.top < window.innerHeight;
    if (onScreen) { hide(); } else { show(); }
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  /* A variant switch rewrites the Add to cart in place, which is what flips a
     product between the two anchors. Without this the strip would keep
     following the old one until the next scroll. */
  if (window.MutationObserver && realBtn) {
    new MutationObserver(update).observe(realBtn, {
      attributes: true, childList: true, subtree: true,
      attributeFilter: ['disabled', 'class', 'hidden', 'style']
    });
  }

  /* ── Watch toggle ───────────────────────────────────────────────────────
     Same principle as the basket button: drive the page control rather than
     write to localStorage from here. The product page already owns the
     ll_watchlist contract, the per-customer mirror, the price snapshot and the
     ll:watchlist:change dispatch. A second writer here would be a second
     source of truth for the same key, and they would drift.

     There are two [data-pdp-watch] controls on the page and they stay in sync
     with each other, so clicking the first is enough.                        */
  var watchBtn = bar.querySelector('[data-llbb-watch]');

  if (watchBtn && pageWatch) {
    watchBtn.hidden = false;

    var syncWatch = function () {
      var on = pageWatch.getAttribute('aria-pressed') === 'true';
      watchBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      watchBtn.setAttribute('aria-label', on ? 'Remove from watchlist' : 'Watch this product for alerts');
    };

    watchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      pageWatch.click();
      /* The page handler flips aria-pressed synchronously, but mirror on the
         event too so this stays right if that ever becomes async. */
      syncWatch();
    });

    syncWatch();
    document.addEventListener('ll:watchlist:change', syncWatch);
  }

}());

/* ── Bottom stack offsets (phones) ───────────────────────────────────────────
   Three fixed elements share the bottom of a product page: the tab bar, the
   section's own sticky purchase bar, and the identity strip above it. Each
   was positioned independently of the other two, so they collided. Measured
   on a 375px screen: the strip's lower edge sat 10px inside the purchase bar,
   and the purchase bar, at z-index 2147483000, painted straight across the
   whole tab bar. A hit test at the Home tab returned the purchase bar, so the
   mobile navigation was unreachable on every product page.

   The heights cannot be hardcoded here. The purchase bar changes height with
   what it holds (Add to basket, Pre-Order Now, or a Discord alerts link), and
   both change with the safe area. So each bar publishes the height it
   actually measures, and the CSS stacks on those.

   offsetHeight is the laid-out height and ignores the transform each bar uses
   to slide in and out, so a bar that is currently down still measures true.
   */
(function () {
  'use strict';

  var root = document.documentElement;
  var pdpBar = document.querySelector('.ll-pdp__bar');
  var buyBar = document.querySelector('[data-ll-buybar]');
  if (!pdpBar && !buyBar) return;

  var measure = function () {
    var pdpOn = !!pdpBar && pdpBar.getAttribute('data-on') === 'true';
    var buyUp = !!buyBar && buyBar.classList.contains('is-up');
    root.style.setProperty('--ll-pdpbar-h', pdpOn ? Math.round(pdpBar.offsetHeight) + 'px' : '0px');
    root.style.setProperty('--ll-buybar-h', buyUp ? Math.round(buyBar.offsetHeight) + 'px' : '0px');
  };

  measure();
  window.addEventListener('resize', measure, { passive: true });

  /* Both bars are toggled by an attribute or a class, so watching those is
     enough. Deliberately NOT on scroll: this reads offsetHeight, and forcing
     layout on every scroll frame to re-learn a height that has not changed is
     exactly the cost these bars exist to avoid. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(measure);
    if (pdpBar) mo.observe(pdpBar, { attributes: true, attributeFilter: ['data-on'] });
    if (buyBar) mo.observe(buyBar, { attributes: true, attributeFilter: ['class', 'hidden'] });
  }
}());

/* ── About prose disclosure (phones) ────────────────────────────────────────
   Clamps the welcome/about columns and adds a control to open them.

   Applied from script rather than markup so that with JavaScript off the prose
   renders in full. Content should never be hidden by a clamp that nothing can
   release.

   Only clamps when there is enough text to be worth clamping, so short copy is
   left alone instead of gaining a pointless Read more button.                */
(function () {
  'use strict';

  var cols = document.querySelector('.llwa__cols');
  if (!cols) return;

  var phone = window.matchMedia('(max-width: 767px)');
  var CLAMP = 150;
  var MIN_WORTH_CLAMPING = 240;
  var btn = null;

  var build = function () {
    if (btn) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'llwa-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>Read more</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

    btn.addEventListener('click', function () {
      var open = cols.classList.toggle('is-clamped') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = btn.querySelector('span');
      if (label) label.textContent = open ? 'Show less' : 'Read more';
      /* Collapsing from below the fold would leave the reader stranded further
         down the page than where they started, so bring the block back. */
      if (!open) {
        var top = cols.getBoundingClientRect().top;
        if (top < 0) cols.scrollIntoView({ block: 'start' });
      }
    });

    if (cols.parentNode) cols.parentNode.insertBefore(btn, cols.nextSibling);
  };

  var apply = function () {
    if (!phone.matches) {
      cols.classList.remove('is-clamped');
      if (btn) btn.hidden = true;
      return;
    }
    /* scrollHeight is the unclamped height, so measure before clamping */
    var full = cols.classList.contains('is-clamped') ? cols.scrollHeight : cols.getBoundingClientRect().height;
    if (full < MIN_WORTH_CLAMPING) return;
    build();
    if (btn) btn.hidden = false;
    if (btn.getAttribute('aria-expanded') !== 'true') cols.classList.add('is-clamped');
  };

  apply();

  /* addEventListener on MediaQueryList is not in older Safari, which only has
     addListener. Try the modern one and fall back rather than throwing. */
  if (phone.addEventListener) { phone.addEventListener('change', apply); }
  else if (phone.addListener) { phone.addListener(apply); }
}());

/* ── Full-screen search (phones) ─────────────────────────────────────────────
   Bound to Shopify's own predictive search, which is what the search page
   matches on, so the sheet and the results it opens agree.

     /search/suggest.json?q=<query>&resources[type]=product&...

   It used to call XCloud's index at app.cloudsearchapp.com/api/v1/search. That
   was the right call while XCloud was the store's search; it stopped being so
   once the search page moved onto Shopify matching with our own filters, and
   it left the phone's main search entry point depending on an app nothing else
   needed. It also failed silently: the render ran only on a 2xx, so losing the
   app would have given shoppers a search box that typed and returned nothing.

   Response fields used: resources.results.products[] of
   {title, url, image, featured_image, price, price_min, price_max}.

   NO RESULT COUNT. XCloud returned numFoundProducts and this showed it.
   Predictive search does not report a total, and the only honest way to get one
   is a second request per keystroke, so the count is gone rather than guessed.

   Rows are built with DOM methods and textContent, never innerHTML. Product
   names are merchant data and building markup from them would be an injection
   path for anything that ever ends up in a product title.

   The tab bar's Search entry stays a real link and this intercepts the tap, so
   with no JavaScript it navigates to the search page exactly as before.      */
(function () {
  'use strict';

  var sheet = document.getElementById('ll-search-sheet');
  if (!sheet) return;

  var input = sheet.querySelector('[data-llss-input]');
  var form = sheet.querySelector('[data-llss-form]');
  var clearBtn = sheet.querySelector('[data-llss-clear]');
  var recentWrap = sheet.querySelector('[data-llss-recent]');
  var recentList = sheet.querySelector('[data-llss-recent-list]');
  var browseWrap = sheet.querySelector('[data-llss-browse]');
  var resultsWrap = sheet.querySelector('[data-llss-results]');
  var resultsList = sheet.querySelector('[data-llss-results-list]');
  var resultsHead = sheet.querySelector('[data-llss-results-head]');
  var allLink = sheet.querySelector('[data-llss-all]');
  var emptyMsg = sheet.querySelector('[data-llss-empty]');
  if (!input || !form) return;

  var RECENT_KEY = 'll_recent_searches';
  var MIN_CHARS = 2;
  /* Predictive search caps at 10. Eight rows fill a phone sheet without the
     list becoming something to scroll rather than scan. */
  var LIMIT = 8;
  var lastFocus = null;
  var timer = null;
  var controller = null;

  var open = function () {
    lastFocus = document.activeElement;
    sheet.hidden = false;
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    document.body.classList.add('llss-open');
    paintRecent();
    /* iOS raises the keyboard only for a focus inside a user gesture. This runs
       inside the tab's own click handler, which is what makes the keyboard come
       up rather than needing a second tap on the field. */
    input.focus();
  };

  var close = function () {
    sheet.classList.remove('is-open');
    document.body.classList.remove('llss-open');
    sheet.hidden = true;
    if (controller) { try { controller.abort(); } catch (e) {} }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  var tabLink = document.querySelector('.llmt__tab[href*="/search"]');
  if (tabLink) {
    tabLink.addEventListener('click', function (e) { e.preventDefault(); open(); });
  }

  sheet.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-llss-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) close();
  });

  var readRecent = function () {
    try {
      var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Object.prototype.toString.call(v) === '[object Array]' ? v : [];
    } catch (e) { return []; }
  };

  var pushRecent = function (q) {
    if (!q) return;
    try {
      var list = readRecent().filter(function (x) { return x !== q; });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) {}
  };

  var paintRecent = function () {
    if (!recentWrap || !recentList) return;
    var list = readRecent();
    recentList.textContent = '';
    if (!list.length) { recentWrap.hidden = true; return; }
    recentWrap.hidden = false;
    list.forEach(function (q) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'llss__chip';
      b.textContent = q;
      b.addEventListener('click', function () { input.value = q; run(q); });
      li.appendChild(b);
      recentList.appendChild(li);
    });
  };

  var wipe = sheet.querySelector('[data-llss-wipe]');
  if (wipe) {
    wipe.addEventListener('click', function () {
      try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
      paintRecent();
    });
  }

  var money = function (n) {
    var cfg = (window.sq && window.sq.config) || {};
    var sym = cfg.currencySymbol || String.fromCharCode(163);
    var v = Number(n);
    return isNaN(v) ? '' : sym + v.toFixed(2);
  };

  /* Shopify CDN sizing. These draw at 46px, so 92 covers 2x without shipping a
     full-size product photo to a phone on every keystroke. */
  var thumb = function (src) {
    if (!src) return '';
    if (src.indexOf('cdn.shopify.com') === -1 || /[?&]width=/.test(src)) return src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=92';
  };

  var render = function (data, q) {
    var products = (data && data.resources && data.resources.results &&
                    data.resources.results.products) || [];
    resultsList.textContent = '';

    if (!products.length) {
      resultsWrap.hidden = true;
      if (allLink) allLink.hidden = true;
      emptyMsg.hidden = false;
      return;
    }

    emptyMsg.hidden = true;
    resultsWrap.hidden = false;

    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'llss__row';
      a.href = p.url || '/search?q=' + encodeURIComponent(q);

      var src = thumb(p.image || (p.featured_image && p.featured_image.url));
      if (src) {
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        img.width = 46;
        img.height = 46;
        a.appendChild(img);
      }

      var meta = document.createElement('div');
      meta.className = 'llss__row-meta';

      var t = document.createElement('span');
      t.className = 'llss__row-title';
      t.textContent = p.title || '';
      meta.appendChild(t);

      if (p.price !== undefined && p.price !== null) {
        var pr = document.createElement('span');
        pr.className = 'llss__row-price';
        /* price is the low end of the range. Saying a flat price for a product
           whose variants differ would be quoting one the shopper may not get. */
        var ranged = p.price_min !== undefined && p.price_max !== undefined &&
                     String(p.price_min) !== String(p.price_max);
        pr.textContent = (ranged ? 'From ' : '') + money(p.price);
        meta.appendChild(pr);
      }

      a.appendChild(meta);
      a.addEventListener('click', function () { pushRecent(q); });
      resultsList.appendChild(a);
    });

    /* Predictive search reports no total, so this says what it actually is:
       the top matches, and a way through to the full set. It used to print
       XCloud numFoundProducts, and inventing a number here to replace it would
       be worse than not showing one. */
    if (resultsHead) resultsHead.textContent = 'Top matches';
    if (allLink) {
      allLink.hidden = false;
      allLink.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      allLink.textContent = 'See all results';
    }
  };

  var run = function (q) {
    if (controller) { try { controller.abort(); } catch (e) {} }

    if (!q || q.length < MIN_CHARS) {
      resultsWrap.hidden = true;
      emptyMsg.hidden = true;
      if (browseWrap) browseWrap.hidden = false;
      paintRecent();
      return;
    }

    if (browseWrap) browseWrap.hidden = true;
    if (recentWrap) recentWrap.hidden = true;

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=' + LIMIT +
              '&resources[options][unavailable_products]=last' +
              '&resources[options][fields]=title,product_type,vendor,tag,variants.title';

    controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;

    fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) render(data, q); })
      .catch(function (err) {
        /* An aborted request is the next keystroke arriving, not a failure.
           Anything else leaves whatever is already on screen. */
        if (err && err.name === 'AbortError') return;
      });
  };

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = q.length === 0;
    clearTimeout(timer);
    /* 220ms skips most intermediate keystrokes while still feeling like the
       results track typing. */
    timer = setTimeout(function () { run(q); }, 220);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      run('');
      input.focus();
    });
  }

  form.addEventListener('submit', function () {
    var q = input.value.trim();
    pushRecent(q);
    /* The visible field is named llq so XCloud's overlay does not attach to it,
       so the real q parameter has to be filled in here or the search page gets
       none. That name can revert to q once the app is uninstalled. */
    var hidden = form.querySelector('[data-llss-q]');
    if (hidden) hidden.value = q;
  });
}());

/* ── Live Bag badge ──────────────────────────────────────────────────────────
   The badge is server rendered from cart.item_count, which is correct on first
   paint and then frozen: adding to cart happens over AJAX, so the number sat
   stale until the next full page load.

   Three ways of hearing about a change, deliberately overlapping, because the
   store adds to cart from several places (product form, cart drawer, quick add
   on cards, apps) and they do not all announce it the same way:

     1. The theme's own events. It already dispatches several names, so listen
        to all of them rather than betting on which one fires where.
     2. The theme's own [data-cart-count] element, which it keeps updated.
        Mirroring it costs nothing and needs no network call.
     3. Watching cart mutation requests directly. This is the backstop for
        anything that changes the cart without announcing it, including apps.

   Whichever fires, the count is re-read from /cart.js rather than guessed, so
   the badge cannot drift from the real cart.                                  */
(function () {
  'use strict';

  var badge = document.querySelector('[data-llmt-cart-count]');
  if (!badge) return;

  var paint = function (n) {
    if (typeof n !== 'number' || isNaN(n) || n < 0) return;
    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n === 0;
  };

  var inFlight = false;
  var refresh = function () {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c.item_count); })
      .catch(function () {})
      .then(function () { inFlight = false; });
  };

  /* 1. the theme's own announcements */
  ['cart:updated', 'cart:refresh', 'cart:build', 'cartcount:update',
   'll:cart:change', 'll:cart:updated', 'theme:cart:change']
    .forEach(function (name) {
      document.addEventListener(name, refresh);
      window.addEventListener(name, refresh);
    });

  /* 2. mirror the count the theme already maintains, no request needed */
  var themeCount = document.querySelector('[data-cart-count]');
  if (themeCount && window.MutationObserver) {
    new MutationObserver(function () {
      var n = parseInt(String(themeCount.textContent || '').replace(/[^0-9]/g, ''), 10);
      if (!isNaN(n)) paint(n);
    }).observe(themeCount, { childList: true, subtree: true, characterData: true });
  }

  /* 3. backstop: notice cart mutations on the wire.
        Both patches call through to the original, so anything else that has
        wrapped fetch or XHR, the search app included, keeps working. */
  var isCartWrite = function (url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  };

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = null;
      try {
        var a = arguments[0];
        url = (typeof a === 'string') ? a : (a && a.url) ? a.url : null;
      } catch (e) {}
      var out = origFetch.apply(this, arguments);
      if (isCartWrite(url) && out && out.then) {
        out.then(function () { refresh(); }).catch(function () {});
      }
      return out;
    };
  }

  var OrigOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) {
      this.addEventListener('load', function () { refresh(); });
    }
    return OrigOpen.apply(this, arguments);
  };

  /* Coming back via the back button serves a cached page whose badge is as old
     as the snapshot, so re-read on restore. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
}());

/* ── Back to top (phones) ────────────────────────────────────────────────────
   Two jobs: show the button only once there is something to go back from, and
   guarantee the click scrolls.

   On the click handler: the theme's footer script binds to [data-ll-top], and
   nothing in the theme renders that attribute, so that listener has always been
   attached to nothing. The real control is [data-back-to-top]. Empire's bundle
   does handle it, but rather than depend on a minified third-party listener for
   something this small, this binds directly. Scrolling to 0 twice is harmless
   if both fire.

   Visibility is driven by a passive scroll listener rather than
   IntersectionObserver: the rule is about scroll distance, not about whether
   any particular element is in view, and IO already misled me once on this
   theme by reporting against a clipping ancestor rather than the viewport.   */
(function () {
  'use strict';

  var wrap = document.querySelector('[data-back-to-top]');
  if (!wrap) return;

  var btn = wrap.querySelector('button') || wrap;
  var phone = window.matchMedia('(max-width: 767px)');
  var SHOW_AFTER = 600;

  var update = function () {
    if (!phone.matches) { wrap.classList.remove('is-visible'); return; }
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    wrap.classList.toggle('is-visible', y > SHOW_AFTER);
  };

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    } catch (err) {
      /* older Safari does not take the options object */
      window.scrollTo(0, 0);
    }
  });

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  if (phone.addEventListener) { phone.addEventListener('change', update); }
  else if (phone.addListener) { phone.addListener(update); }
}());

/* ── Hub coaching tips, folded (phones) ──────────────────────────────────────
   The TCG hub opens with two coaching panels between its heading and the first
   product: "Quick tip: find your TCG fast" at 172px and "New: Watchlist" at
   140px. On a 375px screen that is 312px, over a third of the viewport, spent
   on instructions before a shopper reaches anything buyable.

   Both are worth keeping, and neither is worth reading before the shop, so on
   phones each folds to its title line and opens on a tap.

   The panels ship with the hidden attribute and the section reveals them on a
   first visit, so folding happens at load regardless of that state: folding
   something already hidden is harmless, and it means a tip revealed later
   appears folded rather than having to be caught as it appears.
   */
(function () {
  'use strict';

  var tips = document.querySelectorAll('.lltc__tip, .llpz__tip, .llpo__tip, .llwa__tip, .llc__tip, .llur__tip');
  if (!tips.length) return;

  var phone = window.matchMedia('(max-width: 767px)');
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  var wire = function (tip) {
    if (tip.llFoldReady) return;
    tip.llFoldReady = true;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'll-tip-toggle';
    btn.innerHTML = CHEV;
    tip.appendChild(btn);

    var setFolded = function (on) {
      tip.classList.toggle('is-folded', on);
      btn.setAttribute('aria-expanded', on ? 'false' : 'true');
      btn.setAttribute('aria-label', on ? 'Show this tip' : 'Hide this tip');
    };

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setFolded(!tip.classList.contains('is-folded'));
    });

    /* A folded tip is a single line, so the whole row is the target. Guarded on
       the folded state, which is why this can never swallow a tap on Got it or
       View watchlist: those are not rendered while it is folded. */
    tip.addEventListener('click', function () {
      if (tip.classList.contains('is-folded')) setFolded(false);
    });

    tip.llSetFolded = setFolded;
  };

  var apply = function () {
    for (var i = 0; i < tips.length; i++) {
      wire(tips[i]);
      tips[i].llSetFolded(phone.matches);
    }
  };

  apply();

  /* Rotating to a tablet width should hand the full panel back. */
  if (phone.addEventListener) { phone.addEventListener('change', apply); }
  else if (phone.addListener) { phone.addListener(apply); }
}());

/* ── Hub lanes as tabs (phones) ──────────────────────────────────────────────
   The three lanes stack on a phone, which is correct but tall: three rails at
   roughly 500px each. The section head already carries a numbered
   Singles / Sealed / Protect row, built as jump links to exactly these three
   lanes, and on a phone it reads as a tab bar whether or not it behaves like
   one. So it becomes one.

   WHY THE LISTENER IS ON AN ANCESTOR, IN CAPTURE
   The section binds its own click handler to each step button, which scrolls
   the target lane to the top of the viewport. For a jump link that is right.
   For a tab it is not: scrolling the lane to block start pushes the tab row
   itself off screen, so the next tab is unreachable without scrolling back.

   That handler cannot be outrun by registering another one on the same
   button. At the target, capture and bubble listeners both fire in
   registration order, so a capture flag buys nothing there and this file is
   deferred, meaning it registers second. Listening on an ancestor during the
   capture phase does work: capture runs top down, so stopping propagation
   there keeps the event from ever reaching the button.

   The section also runs an IntersectionObserver that marks whichever lane is
   in view. It is left alone deliberately: with one lane displayed it can only
   ever see the active one, so it agrees rather than fights.
   */
(function () {
  'use strict';

  var root = document.querySelector('.lltc');
  if (!root) return;

  var phone = window.matchMedia('(max-width: 767px)');
  var panels = Array.prototype.slice.call(root.querySelectorAll('.lltc__panel'));
  if (!panels.length) return;

  var groups = [];

  panels.forEach(function (panel) {
    var lanesEl = panel.querySelector('.lltc__lanes');
    var steps = Array.prototype.slice.call(panel.querySelectorAll('[data-step]'));
    if (!lanesEl || steps.length < 2) return;

    var lanes = steps.map(function (s) {
      var id = s.getAttribute('data-target');
      /* Ids come from Liquid and can carry characters querySelector would read
         as syntax, so look the lane up by attribute rather than as a selector. */
      return id ? panel.querySelector('[id="' + id + '"]') : null;
    });

    /* Respect whichever step the section already marked, so the tab that opens
       is the one the markup says is first. */
    var start = 0;
    steps.forEach(function (s, i) {
      if (s.getAttribute('aria-current') === 'true') start = i;
    });

    var g = { lanesEl: lanesEl, steps: steps, lanes: lanes, current: start };

    g.activate = function (i) {
      if (!g.lanes[i]) return;
      g.current = i;
      g.lanes.forEach(function (l, j) {
        if (l) l.classList.toggle('is-tab-current', i === j);
      });
      g.steps.forEach(function (s, j) {
        s.setAttribute('aria-current', i === j ? 'true' : 'false');
      });
    };

    groups.push(g);
  });

  if (!groups.length) return;

  var apply = function () {
    groups.forEach(function (g) {
      g.lanesEl.classList.toggle('is-tabbed', phone.matches);
      if (phone.matches) {
        g.activate(g.current);
      } else {
        /* Back to stacked: no lane should be left hidden. */
        g.lanes.forEach(function (l) {
          if (l) l.classList.remove('is-tab-current');
        });
      }
    });
  };

  apply();

  root.addEventListener('click', function (e) {
    if (!phone.matches) return;
    var step = e.target.closest ? e.target.closest('[data-step]') : null;
    if (!step) return;

    for (var i = 0; i < groups.length; i++) {
      var at = groups[i].steps.indexOf(step);
      if (at === -1) continue;
      /* Beat the section handler to it: no scroll, just a tab change. */
      e.preventDefault();
      e.stopPropagation();
      groups[i].activate(at);
      return;
    }
  }, true);

  if (phone.addEventListener) { phone.addEventListener('change', apply); }
  else if (phone.addListener) { phone.addListener(apply); }
}());

/* ── Plush hub filters behind one control (phones) ───────────────────────────
   Three filter axes and a sort, for 18 products. The type tiles stay out
   because they are the axis with pictures on it; characters and sizes fold
   behind a Filters button.

   The count on the button is the part that matters. Collapsing a filter that
   is still applied, with no sign of it, leaves a shopper looking at four
   plushies wondering where the rest went. So the button says how many are on,
   and the count is recomputed from the chips themselves rather than tracked
   separately, so it cannot drift from what the section actually filtered.

   Nothing here forces a row back into view. .llpz__chars ships with a hidden
   attribute and the section decides whether there are characters worth
   showing, so opening the panel only stops hiding it: the section still has
   the last word on whether it appears.
   */
(function () {
  'use strict';

  var sec = document.querySelector('.llpz');
  if (!sec) return;

  var bar = sec.querySelector('.llpz__bar');
  var sizeChips = bar && bar.querySelector('.llpz__chips');
  if (!bar || !sizeChips) return;

  var phone = window.matchMedia('(max-width: 767px)');

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'll-filters';
  btn.setAttribute('aria-expanded', 'false');

  var label = document.createElement('span');
  label.textContent = 'Filters';
  var count = document.createElement('span');
  count.className = 'll-filters-n';
  count.hidden = true;
  btn.appendChild(label);
  btn.appendChild(count);
  bar.insertBefore(btn, bar.firstChild);

  /* Anything pressed that is not the "everything" option counts as applied. */
  var applied = function () {
    var n = 0;
    var chips = sec.querySelectorAll('.llpz__chip[aria-pressed="true"]');
    for (var i = 0; i < chips.length; i++) {
      var size = chips[i].getAttribute('data-size');
      var chr = chips[i].getAttribute('data-char');
      if (size && size !== 'all') n++;
      if (chr && chr !== 'all') n++;
    }
    return n;
  };

  var paint = function () {
    var n = applied();
    count.textContent = String(n);
    count.hidden = n === 0;
    btn.setAttribute('aria-label', n ? 'Filters, ' + n + ' applied' : 'Filters');
  };

  var setCollapsed = function (on) {
    sec.classList.toggle('is-filters-collapsed', on);
    btn.setAttribute('aria-expanded', on ? 'false' : 'true');
  };

  btn.addEventListener('click', function () {
    setCollapsed(!sec.classList.contains('is-filters-collapsed'));
  });

  /* The section owns what a chip tap does; this only re-reads the result. */
  sec.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.llpz__chip')) {
      setTimeout(paint, 0);
    }
  });

  var apply = function () {
    setCollapsed(phone.matches);
    paint();
  };

  apply();
  if (phone.addEventListener) { phone.addEventListener('change', apply); }
  else if (phone.addListener) { phone.addListener(apply); }
}());
